import type { Maintenance } from "@statuspage/shared";

interface MaintenanceBannerProps {
  maintenance: Maintenance;
}

function formatDateTime(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleString("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export default function MaintenanceBanner({ maintenance }: MaintenanceBannerProps) {
  const endDate = new Date(
    new Date(maintenance.scheduled_at).getTime() + maintenance.duration_min * 60_000
  );

  return (
    <div
      className="rounded-lg border border-blue-200 bg-blue-50 p-4 dark:border-blue-800 dark:bg-blue-950"
      role="status"
      aria-label="Geplante Wartung"
    >
      <div className="flex items-start gap-3">
        <svg
          className="mt-0.5 h-5 w-5 flex-shrink-0 text-blue-600 dark:text-blue-300"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <div>
          <p className="text-sm font-medium text-blue-900 dark:text-blue-100">
            Scheduled Maintenance: {maintenance.title}
          </p>
          <p className="mt-1 text-xs text-blue-700 dark:text-blue-200">
            {formatDateTime(maintenance.scheduled_at)} —{" "}
            {formatDateTime(endDate.toISOString())}
          </p>
          {maintenance.description && (
            <p className="mt-1 text-sm text-blue-800 dark:text-blue-200/90 whitespace-pre-wrap">
              {maintenance.description}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
